import apiClient from '../../../../api/axios.js';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { TLockUserRequest, TLockUserResponse, TUnlockUserResponse } from './schemas';

const STAFF_BASE_URL = '/restaurant-user';
const QUERY_KEY = 'restaurant-staff';

export const useLockUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ userId, reason }: { userId: string; reason?: string }) => {
      const payload: TLockUserRequest = reason ? { reason } : {};
      const response = await apiClient.put<TLockUserResponse>(
        `${STAFF_BASE_URL}/${userId}/lock`,
        payload
      );
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
    },
  });
};

export const useUnlockUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (userId: string) => {
      const response = await apiClient.put<TUnlockUserResponse>(
        `${STAFF_BASE_URL}/${userId}/unlock`
      );
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
    },
  });
};

export const staffService = {
  useLockUser,
  useUnlockUser,
};
